import React from 'react';
import './Pages.css';

const Refund = () => {
  return React.createElement(
    'main',
    { className: 'page-content' },
    React.createElement(
      'div',
      { className: 'container' },
      React.createElement('h1', null, 'Cancellation & Refund Policy'),
      React.createElement('p', null, 'We strive to ensure your satisfaction with our services. This policy outlines our cancellation and refund procedures...'),
      React.createElement('h3', null, 'Cancellation Policy'),
      React.createElement('p', null, 'You may cancel your service request within 24 hours of placing the order for a full refund...'),
      React.createElement('h3', null, 'Refund Process'),
      React.createElement('p', null, 'Refunds will be processed within 7-10 business days to the original payment method...'),
      React.createElement('h3', null, 'Non-Refundable Services'),
      React.createElement('p', null, 'Services that have been completed or delivered cannot be refunded...')
    )
  );
};

export default Refund;